import { DownloadStatusVO } from "../download-statusVO";

export class DocumentoGescorVO {
  id: string;
  hash: string;
  nome: string;
  primario: boolean;
  preview: boolean;
  info: DownloadStatusVO = new DownloadStatusVO();
}
